module.exports = __webpack_public_path__ + "img/ic_mainservice_thrift.4dade6ca.svg";